import {
    SET_PREVIEW_QUESTIONLIST_SUCCESS,
    SET_PREVIEW_DISPLAY_SUCCESS,
    SET_PREVIEW_QUIZ_SUCCESS,
    SET_PREVIEW_QUIZ_SETTINGS_SUCCESS
} from './constants';


const quizPreview = {
    quiz: {},
    question: {},
    settings: {
        displayPreview: '',
        quizSettings: {}

    }
};

const quizPrewievReducer = ( state = quizPreview, action ) => {

    switch ( action.type ) {
        case SET_PREVIEW_QUESTIONLIST_SUCCESS: {
            return { ...state, question: { ...action.val } };
        }

        case SET_PREVIEW_QUIZ_SUCCESS: {
            return { ...state, quiz: { ...action.val } };
        }

        case  SET_PREVIEW_DISPLAY_SUCCESS: {
            return { ...state, settings: { displayPreview: action.val } };
        }

        case SET_PREVIEW_QUIZ_SETTINGS_SUCCESS: {
            return { ...state, settings: { ...state.settings, quizSettings: { ...action.val } } };
        }

        default:
            return state;
    }
};

export { quizPrewievReducer as quizpreview };
